if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 

            /* Wishlist Footer selectors */
            this.wishlistFooter = this.querySelector('#swymcs-total-container');
            this.subTotalField = this.querySelector('#swymcs-wishlist-total');
            this.addAddToCartButton = this.querySelector('#swymcs-add-all-to-cart-btn');
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));

            /* Wishlist Footer buttons */
            this.addAddToCartButton.addEventListener('click', this._addAllProductToCart.bind(this));
        }

        async _triggerBackToListView(){
            this._renderWishlist(_swat);
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getLists();
            this.lists.length ? this._renderWishlists() : this._renderEmptyState();
        }

        async _renderShareWishlist(){
            const params = new URL(document.location).searchParams;
            const lid = params.get("lid");
            if(!lid){
                this._renderProductsGrid([]);
                this._hideContainer(this.wishlistHeader);
                this._hideContainer(this.backToListView)
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSharedListHeader(lid);
            this._renderProductsGrid(shopifyProductsData);
            this._hideContainer(this.backToListView)
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderWishlists() {
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            let html = ``;
            this.lists.forEach(list => {
                const listContents = list?.listcontents || [];

                let buttonText = !listContents.length ? 'Continue Shopping' : 'View List';
                let buttonAction = !listContents.length ? 'shop' : 'view-list';
                let imageHtml = `<div class="swymcs-list-image-container">`;
                if(listContents.length){
                    for(let i = 0; i < 3; i++){
                        if(listContents[i]){
                            imageHtml += `
                                <div class="swymcs-wishlist-image-wrapper">
                                    <img src="${listContents[i].iu}" alt="${listContents[i].dt}" class="swymcs-wishlist-image"/>
                                </div>`;
                        }
                    }
                    imageHtml += '</div>';
                }
                else imageHtml += ` <p class="swymcs-no-products-message">This is an empty list!</p></div>`;

                html += `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" data-lid="${list.lid}" aria-label="View list ${list.lname}" id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${listContents.length}</span>
                            <span class="swymcs-product-count-text">${listContents.length > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" data-action="${buttonAction}" id="swymcs-view-list-button-${list.lid}" aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            });
            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._scrollToTop();
        }

        async _renderListProducts(lid){
            window.currentActiveListId = lid;
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            this._renderListHeader(lid);
            this._renderProductsGrid(shopifyProductsData);
            this._hideContainer(this.listsContainer);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(lid){
            const activeList = await this._getListDetails(lid);
            this._renderActiveList(activeList.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${listContents[0].iu}" alt="listContents[0].dt"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const listContent = list?.listcontents || [];
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts){
            if(!shopifyProducts.length) {
                this._renderEmptyList();
                return;
            }
            let productMarkup = ``;
            shopifyProducts.forEach(async (pdp, index) => {
                if(!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const labelText = product.metafieldData != 'NA' ? product.metafieldData : '';
                let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const productUrl = pdp?.product?.du || pdp.du;
                const additionalClasses = labelText.toLowerCase().includes('sold out') ? 'product-card__images product-card__images__soldout' : 'product-card__images';
                let labelHtml = '';
                const isProductSoldOut = labelText.toLowerCase().includes('sold out') ? 'swymcs-sold-out' : '';

                if(labelText){
                    labelHtml = labelText.toLowerCase().includes('coming soon') ? `<div class="grid-product__tag grid-product__tag--coming-soon" bis_skin_checked="1">${labelText}</div>` : `<div class="grid-product__tag grid-product__tag--sold-out" bis_skin_checked="1">${labelText}</div>`;
                    addToCartBtnText = labelText;
                    isButtonDisabled = 'disabled';
                    isSoldOut = labelText.toLowerCase().includes('coming soon') ? '' : 'swymcs-sold-out'; 
                }
                let variantsHTML = `<div class="container" bis_skin_checked="1">`;

                if(!isProductSoldOut){
                    if(product.variants.length == 1){
                        let isVariantAvailable = selectedVariant.available ? 'style="font-weight: bold"' : 'disabled style="color: gray"' ;
                        variantsHTML += selectedVariant.title.toLowerCase != 'default title' ? `<button ${isVariantAvailable} data-purpose="select" data-variant-id="${selectedVariant.id}" data-product-id="${product.id}" class="swym-selected-variant swymcs-variant-selector-btn" aria-label="Select ${selectedVariant.title}">${selectedVariant.title}</button>`: ''; 
                    } else {
                        product.variants.forEach((variant, index) => {
                            const variantCost = parseFloat(variant.price/100.00).toFixed(2);
                            const isComingSoonProduct = labelText ? 'swymcs-coming-soon-variant' : '';
                            let isSelectedVariant = variant.id == selectedVariant.id ? 'swym-selected-variant' : ''; 
                            let isVariantAvailable = !variant.available && !labelText ? 'disabled style="color: gray"' : 'style="font-weight: bold"';
                            variantsHTML += `<button data-variant-cost="${variantCost}" data-purpose="select" ${isVariantAvailable} data-variant-id="${variant.id}" data-product-id="${product.id}" class="${isSelectedVariant} ${isComingSoonProduct} swymcs-variant-selector-btn" aria-label="Select ${variant.title}">${variant.title}</button>`;
                        })
                    }
                }

                variantsHTML += `</div>`;
                productMarkup += `
                <div data-bg-image="${imageSrc}" class="swymcs-product-card ${isProductSoldOut} product-card grid-product__has-quick-shop product-card--slide-preview" bis_skin_checked="1" id="wishlist-grid-item--${index}" data-url="${pdp.du}" data-lid="${lid}" data-epi="${pdp.epi}">
                    <div class="samita-product-card__images ${additionalClasses}" bis_skin_checked="1">
                        <div class="swymcs-wl-action-cta-container">
                            <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-button swymcs-product-delete-btn swym-nav swym-nav-1 swym-is-button" aria-label="${this.settings.swym_delete_list_text} ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                        </div>
                        ${labelHtml}
                        <a href="${productUrl}" class="samita-grid-product_links">
                            <pre></pre>
                            <img class="lazyload product__background-image product__background-image--first sami-grid-img" data-srcset="${imageSrc}" src="${imageSrc}"/>
                        </a>
                        <button ${isButtonDisabled} data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" class="btn btn--primary ${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}" data-variant-cost="${selectedVariantPrice}">
                            ${addToCartBtnText}
                        </button>
                    </div>
                    <div class="product-card__description-container" bis_skin_checked="1">
                        <a href="${productUrl}">
                            <h2 class="product-card__title">${product.title}</h2>
                            ${variantsHTML}
                            <p class="product-card__price">${currencyCode}${selectedVariantPrice}</p>
                        </a>
                    </div>
                </div>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
            this._updatePageFooter();
        }

        _updatePageFooter(){
            const wishlistedItems = this.querySelectorAll('.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)');
            let prices = [];
            wishlistedItems.forEach(container => {
                prices.push(+container.dataset.variantCost);
            });
            if(wishlistedItems.length){
                const totalPrice = parseFloat(prices.reduce(((sum, price, index)=> sum + price), 0)).toFixed(2);
                this.subTotalField.innerHTML = `${currencyCode}${totalPrice}`;
                this._showContainer(this.wishlistFooter);
            } else this._hideContainer(this.wishlistFooter);
        }

        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
            this._hideContainer(this.wishlistFooter);
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }
      
       async _getShopifyProductsData(products){
            if(!products.length) return []; 
            const section = this;   
            let buggedProductsArray = []; 
            let res = await Promise.all(products.map(async (pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `https://${window.shopDomain}/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    jsonData.metafieldData = await section._fetchProductMetafield(reqURL);
                    pdp.productData = jsonData;
                    return pdp;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[pdp.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));

            console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            console.log(res, 'respnse')
            return res;
        }

        async _fetchProductMetafield(url){
            const sectionHtml = await(await fetch(`${url}?section_id=swym-product-metafield-status`)).text();
            return new DOMParser().parseFromString(sectionHtml,"text/html").getElementById("swym-product-button-text").value; 
        }

        _deleteProductFromList(product, lid, parentNode){
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                this.lists = await this._getLists();
                this._renderListHeader(lid);
                this._updatePageFooter();
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
                "lnote": ""
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                this.lists = await this._getLists();
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                this.lists = await this._getLists();
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this._renderWishlist(_swat);
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to cart'; 
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            }, (error) => {
                button.textContent = 'Add to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        async _addAllProductToCart(evt) {
            const page = this;
            try {
                const productsData = [...page.querySelectorAll('.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)')].map(container => ({
                    id: +container.dataset.epi,
                    quantity: 1
                }));
                let formData = { 'items': productsData };
        
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
        
                const cartResponse = await response.json();
                cartResponse.items.forEach(item => {
                    const variantId = item.id;
                    const button = page.querySelector(`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`);
                    button.textContent = 'Added to cart';
                });
                evt.target.textContent = 'Added to cart';
                this._scrollToTop();
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            } catch (error) {
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error:', error);
            }
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        /* Product Grid Events */
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return; 
            evt.preventDefault();
            if(purpose == 'cart') page._addProductToCart(target);
            else if(purpose == 'select') page._selectProductSize(target);
            else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card')
                );
            }
        }

        _selectProductSize(sizeButton){
            const selectedVariantClass = 'swym-selected-variant';
            const parentNode = sizeButton.closest('.swymcs-product-card');
            const addToCartButton = parentNode.querySelector('.swymcs-add-to-cart-btn');
            // If selected variant is clicked - DO NOTHING
            if(sizeButton.classList.contains(selectedVariantClass)) return; 

            // Switch selected variants
            parentNode.querySelector(`.${selectedVariantClass}.swymcs-variant-selector-btn`).classList.remove(selectedVariantClass);
            sizeButton.classList.add(selectedVariantClass);

            // If Product is "Coming Soon" - Just change selected size and DO NOTHING 
            if(sizeButton.classList.contains('swymcs-coming-soon-variant')) return;

            // Perform proper logical functions
            addToCartButton.removeAttribute('disabled');
            addToCartButton.classList.remove('swymcs-sold-out');
            const variantId = sizeButton.dataset.variantId;
            const variantCost = sizeButton.dataset.variantCost;
            const addToCartBtnText = this.swat.platform.isInDeviceCart(variantId) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`;
            addToCartButton.setAttribute('data-epi', variantId);
            addToCartButton.setAttribute('data-variant-cost', variantCost);
            addToCartButton.textContent = addToCartBtnText;
            this._updatePageFooter();
        }

        /* Additional Options */


    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}